export const PRODUCT_IMAGE_URL = `${process.env.REACT_APP_MAGENTO_URI}/pub/media/catalog/product`

export enum StoreView {
  SofiaAndGrace = 'default',
  LivBrite = 'livbrite_default_storeview'
}

export const KEY_CODES = {
  ENTER: 13
}

export const BP = {
  xxs: {
    min: '374px',
    max: '373px'
  },
  xs: {
    min: '576px',
    max: '575px'
  },
  sm: {
    min: '768px',
    max: '767px'
  },
  md: {
    min: '992px',
    max: '991px'
  },
  lg: {
    min: '1280px',
    max: '1199px'
  },
  max: '1600px'
}

export const SOCIAL_NETWORKS = {
  INSTAGRAM: {
    URL: 'https://www.instagram.com/minervabeauty/'
  },
  FACEBOOK: {
    URL: 'https://www.facebook.com/MinervaBeauty'
  },
  PINTEREST: {
    URL: 'https://www.pinterest.com/minervabeauty1/'
  },
  TWITTER: {
    URL: 'https://twitter.com/minervabeauty'
  },
  YOUTUBE: {
    URL: 'https://www.youtube.com/user/minervabeautyinc'
  }
}

export const CMS_BLOCK = {
  BLOG_HERO: 'blog-hero',
  PROMO_BANNER: 'promo_banner'
}

export const SORT_BY = ['price', 'name']

export const PACKAGE = {
  EACH: 'Each',
  BAG: 'Bag'
}

export const PO_BOX_REGEX: RegExp = /^((?!((P(\.)?O(\.)(\s?)BOX)|(P(\.)?O(\s?)(\.)BOX)|(P(\.)?O(\s?)BOX)|(PO(\s?)BOX)|(POST(\s?)OFFICE)|(POSTAL(\s?)OFFICE))).)*$/gi

export const SIZES: { [key: string]: string } = {
  'X-Small': 'XS',
  Small: 'S',
  Medium: 'M',
  Large: 'L',
  'X-Large': 'XL',
  'XX-Large': 'XXL',
  'XXX-Large': 'XXXL',
  'Small/Medium': 'S/M',
  'Large/X-Large': 'L/XL'
}

export const SWATCHES_ATTRIBUTES = {
  SIZE: 'size'
}
